import React, { Children } from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  number: 1,
  title: 'Todos los Códigos que Necesitas para Construir una Página de Producto Ganadora',
  description: 'Secciones, estructuras y snippets listos para aumentar conversión.',
  price: 25000,
  type: 'ebook',
  color: 'bg-[#00c853]'
}, {
  number: 2,
  title: 'Cómo Crear Portadas de Productos que Venden: Diseños Profesionales con IA',
  description: 'Plantillas editables para creatividades y presentaciones premium.',
  price: 30000,
  type: 'monitor',
  color: 'bg-gray-100'
}, {
  number: 3,
  title: 'Cómo Encontrar Ofertas de Productos Ganadores Ya Validados',
  description: 'Cómo detectar ofertas ganadoras y modelar sin copiar.',
  price: 12000,
  type: 'ebook',
  color: 'bg-[#1565c0]'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
const EbookMockup = ({
  title,
  color
}: {
  title: string;
  color: string;
}) => <div className="relative w-40 h-56 sm:w-48 sm:h-64 mx-auto perspective-1000" data-id="element-34">
    <div className="absolute top-4 left-4 w-full h-full bg-black/20 blur-md rounded-r-lg" data-id="element-35" />
    <div className={`absolute inset-0 ${color} rounded-r-lg shadow-xl border-l-[12px] border-white/30 flex flex-col items-center justify-center p-4 text-center transform transition-transform hover:-translate-y-2 duration-300`} data-id="element-36">
      <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-black/20" data-id="element-37" />
      <div className="absolute left-[10px] top-0 bottom-0 w-[1px] bg-white/40" data-id="element-38" />
      <div className="w-12 h-12 mb-4 bg-white/20 rounded-full flex items-center justify-center" data-id="element-39">
        <span className="text-2xl" data-id="element-40">✨</span>
      </div>
      <h4 className="text-white font-bold text-sm sm:text-base leading-tight uppercase tracking-wider" data-id="element-41">
        {title}
      </h4>
    </div>
  </div>;
const MonitorMockup = () => <div className="relative w-56 h-48 sm:w-64 sm:h-56 mx-auto flex flex-col items-center justify-end transform transition-transform hover:-translate-y-2 duration-300" data-id="element-42">
    <div className="w-full h-36 sm:h-44 bg-gray-800 rounded-t-xl rounded-b-sm p-2 shadow-xl relative z-10 border-b-8 border-gray-700" data-id="element-43">
      <div className="w-full h-full bg-white rounded-sm overflow-hidden flex flex-col" data-id="element-44">
        <div className="w-full h-3 bg-gray-200 flex items-center px-1 gap-1" data-id="element-45">
          <div className="w-1.5 h-1.5 rounded-full bg-red-400" data-id="element-46" />
          <div className="w-1.5 h-1.5 rounded-full bg-yellow-400" data-id="element-47" />
          <div className="w-1.5 h-1.5 rounded-full bg-green-400" data-id="element-48" />
        </div>
        <div className="flex-1 p-2 flex gap-2" data-id="element-49">
          <div className="w-1/4 h-full bg-gray-100 rounded flex flex-col gap-1 p-1" data-id="element-50">
            <div className="w-full h-2 bg-gray-300 rounded" data-id="element-51" />
            <div className="w-full h-2 bg-gray-200 rounded" data-id="element-52" />
            <div className="w-full h-2 bg-gray-200 rounded" data-id="element-53" />
          </div>
          <div className="flex-1 h-full flex flex-col gap-2" data-id="element-54">
            <div className="w-full h-1/2 bg-brand-green/20 rounded" data-id="element-55" />
            <div className="flex gap-2 h-1/2" data-id="element-56">
              <div className="flex-1 bg-gray-100 rounded" data-id="element-57" />
              <div className="flex-1 bg-gray-100 rounded" data-id="element-58" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="w-12 h-8 sm:h-10 bg-gradient-to-b from-gray-400 to-gray-500 relative z-0" data-id="element-59" />
    <div className="w-24 h-2 bg-gray-400 rounded-t-lg shadow-md" data-id="element-60" />
  </div>;
export function BonusSection() {
  return <section className="w-full bg-brand-bg pt-6 md:pt-8 pb-16 md:pb-24 px-6" data-id="element-61">
      <div className="max-w-5xl mx-auto" data-id="element-62">
        {/* Bonos title image */}
        <motion.div className="flex justify-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-63">
          <img src="https://cdn.magicpatterns.com/uploads/uARZ8dpRHx3HRk5B6p9st7/Imagen_28-3-26_a_las_10.16_p._m..jpg" alt="Bonos Exclusivos - Comprando el ebook accederá a 3 increíbles regalos" className="w-full h-auto" data-id="element-64" />
        </motion.div>

        {/* Subtitle image */}
        <motion.div className="flex justify-center mb-16 md:mb-20" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.1
      }} data-id="element-65">
          <img src="https://cdn.magicpatterns.com/uploads/jN9Zd5RssSboAL3nBUmW6r/Imagen_28-3-26_a_las_10.21_p._m..jpg" alt="Con la compra del curso te llevas GRATIS" className="w-full max-w-xl h-auto" data-id="element-66" />
        </motion.div>

        {/* Bonus Rows */}
        <motion.div className="flex flex-col gap-12 md:gap-16" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.1
      }} data-id="element-67">
          {bonuses.map(bonus => <motion.div key={bonus.number} variants={itemVariants} className="flex flex-col md:flex-row items-center gap-8 md:gap-12 bg-white rounded-3xl p-8 shadow-lg border border-gray-100 hover:shadow-2xl hover:border-brand-green/30 transition-all duration-300" data-id="element-68">
              <div className="w-full md:w-1/3 flex justify-center shrink-0" data-id="element-69">
                {bonus.type === 'ebook' ? <EbookMockup title={bonus.title} color={bonus.color} data-id="element-70" /> : <MonitorMockup data-id="element-71" />}
              </div>
              <div className="w-full md:w-1/3 flex flex-col text-center md:text-left" data-id="element-72">
                <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 leading-tight mb-3" data-id="element-73">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-lg md:text-xl leading-relaxed" data-id="element-74">
                  {bonus.description}
                </p>
              </div>
              <div className="w-full md:w-1/3 flex flex-col items-center justify-center shrink-0 mt-4 md:mt-0" data-id="element-75">
                <span className="relative inline-block mb-1" data-id="element-76">
                  <span className="text-red-500 font-extrabold text-5xl md:text-6xl tracking-tighter" data-id="element-77">
                    ${bonus.price.toLocaleString()}
                  </span>
                  <span className="absolute left-[-10px] right-[-10px] top-1/2 h-[4px] md:h-[6px] bg-red-500 -rotate-12 rounded-full" aria-hidden="true" data-id="element-78" />
                  <span className="absolute left-[-10px] right-[-10px] top-1/2 h-[4px] md:h-[6px] bg-red-500 rotate-12 rounded-full" aria-hidden="true" data-id="element-79" />
                </span>
                <span className="text-black font-black text-2xl md:text-3xl tracking-wide mt-2" data-id="element-80">
                  HOY GRATIS
                </span>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Lo que incluye - destacado */}
        <motion.div className="mt-16 md:mt-24" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.1
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-81">
          <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 text-center mb-10" data-id="element-82">
            También <span className="text-[#1fa855]" data-id="element-83">incluye</span>:
          </h3>

          <div className="flex flex-col gap-8" data-id="element-84">
            {/* Clase Meta Ads */}
            <div className="bg-white rounded-3xl border-2 border-brand-green/30 shadow-lg overflow-hidden" data-id="element-85">
              <div className="w-full max-w-3xl mx-auto" data-id="element-86">
                <img src="https://cdn.magicpatterns.com/uploads/w84iMHXmFqJCKfTFA9az8N/Imagen_28-3-26_a_las_10.55_p._m._(1).jpg" alt="Clase completa donde te enseño a hacer Campañas de venta en Meta Ads" className="w-full h-auto" data-id="element-87" />
              </div>
            </div>

            {/* Taller Grabado - Embudo de venta */}
            <div className="bg-white rounded-3xl border-2 border-brand-green/30 shadow-lg overflow-hidden" data-id="element-88">
              <div className="w-full max-w-3xl mx-auto" data-id="element-89">
                <img src="https://cdn.magicpatterns.com/uploads/8ndB6Nwy7j6jtMLPPA9ePa/Imagen_28-3-26_a_las_10.55_p._m..jpg" alt="Taller grabado Meta Ads + Shopify - Embudo de venta automática" className="w-full h-auto" data-id="element-90" />
              </div>
            </div>

            {/* Comunidad VIP WhatsApp */}
            <div className="bg-white rounded-3xl border-2 border-brand-green/30 shadow-lg p-8 md:p-10 flex flex-col md:flex-row items-center gap-6" data-id="element-91">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-brand-green/15 flex items-center justify-center flex-shrink-0" data-id="element-92">
                <span className="text-3xl md:text-4xl" data-id="element-93">💬</span>
              </div>
              <div className="text-center md:text-left" data-id="element-94">
                <h4 className="text-xl md:text-2xl font-extrabold text-gray-900 mb-2" data-id="element-95">
                  Comunidad VIP en WhatsApp
                </h4>
                <p className="text-gray-600 text-base md:text-lg leading-relaxed" data-id="element-96">
                  Soporte cercano y respuesta rápida 24/7.
                </p>
              </div>
              <div className="flex-shrink-0" data-id="element-97">
                <span className="inline-block bg-brand-green text-white font-bold text-sm px-4 py-2 rounded-full uppercase tracking-wider" data-id="element-98">
                  Incluido
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Value Stack - Todo lo que te llevás hoy */}
        <motion.div className="mt-16 md:mt-24 w-full" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.1
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-99">
          <div className="relative text-center mb-10" data-id="element-100">
            <div className="absolute left-1/2 -translate-x-1/2 top-[-20%] w-[800px] h-[600px] bg-[#22c55e]/[0.14] rounded-full blur-[120px] pointer-events-none" data-id="element-101" />
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 leading-tight relative z-10" data-id="element-102">
              Todo lo que te <span className="text-[#1fa855]" data-id="element-103">llevás hoy</span>
            </h2>
          </div>

          <div className="flex flex-col gap-4" data-id="element-104">
            {[{
            emoji: '📘',
            name: 'Curso Completo Paso a Paso',
            price: '60.000'
          }, {
            emoji: '🤖',
            name: 'Todos los Códigos que Necesitas para Construir una Página de Producto Ganadora',
            price: '25.000'
          }, {
            emoji: '🛒',
            name: 'Cómo Crear Portadas de Productos que Venden: Diseños Profesionales con IA',
            price: '30.000'
          }, {
            emoji: '📋',
            name: 'Cómo Encontrar Ofertas de Productos Ganadores Ya Validados',
            price: '12.000'
          }, {
            emoji: '🚀',
            name: 'Taller grabado: Meta Ads + Shopify — La fórmula definitiva',
            price: '50.000'
          }, {
            emoji: '📊',
            name: 'Clase completa donde te enseño a hacer campañas de venta en Meta Ads',
            price: '70.000'
          }].map((item, i) => <div key={i} className="flex items-center justify-between bg-brand-green rounded-xl px-5 py-4 md:px-8 md:py-5" data-id="element-105">
                <div className="flex items-center gap-3" data-id="element-106">
                  <span className="text-xl md:text-2xl" data-id="element-107">{item.emoji}</span>
                  <span className="text-white font-semibold text-sm md:text-base leading-snug" data-id="element-108">
                    {item.name}
                  </span>
                </div>
                <span className="text-white font-bold text-sm md:text-base whitespace-nowrap ml-4" data-id="element-109">
                  ${item.price} ARS
                </span>
              </div>)}
          </div>

          {/* Total value box */}
          <div className="mt-10 bg-gray-50 border border-gray-200 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6" data-id="element-110">
            <div data-id="element-111">
              <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-2" data-id="element-112">
                Valor total del sistema:{' '}
                <span className="text-gray-400 line-through font-bold" data-id="element-113">
                  $247.000 ARS
                </span>
              </h3>
              <p className="text-lg md:text-xl text-gray-800 font-bold" data-id="element-114">
                Pero ese <span className="text-red-500" data-id="element-115">NO</span> es el valor
                que vas a pagar hoy.
              </p>
              <p className="text-gray-500 text-base mt-2" data-id="element-116">
                Más abajo vas a poder acceder a todo este sistema completo por
                una inversión mucho menor.
              </p>
            </div>
            <motion.span className="text-brand-green text-5xl md:text-6xl" animate={{
            y: [0, 12, 0]
          }} transition={{
            duration: 1.2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-117">
              ⬇
            </motion.span>
          </div>
        </motion.div>
      </div>
    </section>;
}